// src/theme/shadows.js
// Linear / Vercel tarzi subtle shadow hiyerarsisi.
// Siyah yerine slate (15/20/25) kullanilir · daha yumusak, profesyonel gorunum.
// Her seviye iki katmanli: kisa (1-2px, border hissi) + uzun (blur/offset).

const shadows = {
  xs:   "0 1px 2px 0 rgba(15, 20, 25, 0.05)",
  sm:   "0 1px 2px -1px rgba(15, 20, 25, 0.06), 0 1px 3px 0 rgba(15, 20, 25, 0.08)",
  base: "0 1px 3px 0 rgba(15, 20, 25, 0.08), 0 1px 2px -1px rgba(15, 20, 25, 0.06)",
  md:   "0 2px 4px -2px rgba(15, 20, 25, 0.08), 0 4px 8px -1px rgba(15, 20, 25, 0.08)",
  lg:   "0 4px 6px -2px rgba(15, 20, 25, 0.06), 0 10px 20px -4px rgba(15, 20, 25, 0.10)",
  xl:   "0 8px 12px -4px rgba(15, 20, 25, 0.08), 0 20px 36px -6px rgba(15, 20, 25, 0.12)",
  "2xl": "0 16px 24px -8px rgba(15, 20, 25, 0.12), 0 32px 60px -12px rgba(15, 20, 25, 0.18)",

  inner:      "inset 0 1px 2px 0 rgba(15, 20, 25, 0.06)",
  "inner-lg": "inset 0 2px 4px 0 rgba(15, 20, 25, 0.08)",

  // Chakra default focus outline · brand aksan ile
  outline: "0 0 0 3px var(--chakra-colors-brand-500_alpha_40)",
};

export default shadows;
